(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSync(gallery) {
      if (gallery.__mthSync) return;
      var viewer = gallery.querySelector('[id^="GalleryViewer"]');
      var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
      var slider = viewer && viewer.querySelector('ul.product__media-list');
      if (!slider || !thumbs) return;
      gallery.__mthSync = true;
      var railUl = thumbs.querySelector('ul');
      var previousButton = gallery.querySelector('[data-mth-gallery-direction="previous"]');
      var nextButton = gallery.querySelector('[data-mth-gallery-direction="next"]');
      var active = null;

      function getVisibleThumbnailButtons() {
        return Array.prototype.filter.call(
          thumbs.querySelectorAll('.thumbnail-list__item > button'),
          function (button) {
            var item = button.closest('.thumbnail-list__item');
            return item && item.getClientRects().length > 0;
          }
        );
      }

      function changeDesktopMedia(step) {
        var buttons = getVisibleThumbnailButtons();
        if (buttons.length < 2) return;
        var currentIndex = buttons.findIndex(function (button) {
          return button.hasAttribute('aria-current');
        });
        if (currentIndex < 0) currentIndex = 0;
        var targetIndex = (currentIndex + step + buttons.length) % buttons.length;
        buttons[targetIndex].click();
      }

      if (previousButton) {
        previousButton.addEventListener('click', function () {
          changeDesktopMedia(-1);
        });
      }
      if (nextButton) {
        nextButton.addEventListener('click', function () {
          changeDesktopMedia(1);
        });
      }

      function sync() {
        var slides = slider.querySelectorAll('.product__media-item');
        var center = slider.scrollLeft + slider.clientWidth / 2;
        var best = null,
          min = Infinity;
        slides.forEach(function (s) {
          var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - center);
          if (d < min) {
            min = d;
            best = s;
          }
        });
        if (!best) return;
        var id = best.dataset.mediaId;
        if (id === active) return;
        active = id;
        var thumb = thumbs.querySelector('[data-target="' + id + '"]');
        if (!thumb) return;
        thumbs.querySelectorAll('button[aria-current]').forEach(function (b) {
          b.removeAttribute('aria-current');
        });
        var btn = thumb.querySelector('button');
        if (btn) btn.setAttribute('aria-current', 'true');
        if (railUl && railUl.scrollTo) {
          railUl.scrollTo({
            left: thumb.offsetLeft - railUl.clientWidth / 2 + thumb.offsetWidth / 2,
            behavior: 'smooth',
          });
        }
      }
      var raf = null;
      slider.addEventListener(
        'scroll',
        function () {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            sync();
          });
        },
        { passive: true }
      );
      sync();
    }
    function initAll() {
      document.querySelectorAll('media-gallery').forEach(initSync);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    // Re-arm when a fresh <media-gallery> replaces the old node: Theme Editor
    // section reloads (shopify:section:load) and Dawn's AJAX product swap
    // (handleSwapProduct) both mint a new element that never hit initAll.
    // initSync is idempotent (guarded by __mthSync), so re-running is safe.
    document.addEventListener('shopify:section:load', initAll);
    if (window.MutationObserver) {
      new MutationObserver(function (mutations) {
        for (var m = 0; m < mutations.length; m++) {
          var added = mutations[m].addedNodes;
          for (var n = 0; n < added.length; n++) {
            var node = added[n];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches('media-gallery')) initSync(node);
            else if (node.querySelectorAll) node.querySelectorAll('media-gallery').forEach(initSync);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-price-history"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('price-history')) {
    class PriceHistory extends HTMLElement {
      connectedCallback() {
        if (this.dataset.rendered === 'true') return;
        this.dataset.rendered = 'true';

        const details = this.querySelector('[data-price-history-details]');
        if (details) details.open = false;

        const source = this.querySelector('[data-price-history-data]');
        if (!source) return;

        let data;
        try {
          data = JSON.parse(source.textContent);
        } catch (error) {
          return;
        }

        const fallbackCurrency = data.current && data.current.currency ? data.current.currency : 'USD';
        const entries = (Array.isArray(data.entries) ? data.entries : [])
          .map((entry) => ({
            date: typeof entry.date === 'string' ? entry.date : '',
            price: Number.parseFloat(entry.price),
            currency: entry.currency || fallbackCurrency,
            reason: typeof entry.reason === 'string' ? entry.reason : '',
            approximate: entry.approximate === true
          }))
          .filter((entry) => Number.isFinite(entry.price) && entry.price >= 0)
          .sort((first, second) => first.date.localeCompare(second.date));

        const hasRecordedHistory = entries.length > 0;
        if (!hasRecordedHistory && data.current && Number.isFinite(Number.parseFloat(data.current.price))) {
          entries.push({
            date: '',
            price: Number.parseFloat(data.current.price),
            currency: fallbackCurrency,
            reason: '',
            approximate: false
          });
        }

        if (!entries.length) return;

        const labels = data.labels || {};
        const locale = data.locale || 'en';
        const latest = entries[entries.length - 1];
        const first = entries[0];
        const previous = entries.length > 1 ? entries[entries.length - 2] : null;
        const prices = entries.map((entry) => entry.price);
        const low = Math.min(...prices);
        const high = Math.max(...prices);

        const formatMoney = (price, currency) => new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency || fallbackCurrency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }).format(price);

        const formatDate = (entry) => {
          if (!entry.date) return '';
          const parsed = new Date(`${entry.date}T12:00:00Z`);
          const date = Number.isNaN(parsed.getTime())
            ? entry.date
            : new Intl.DateTimeFormat(locale, {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
              timeZone: 'UTC'
            }).format(parsed);
          return entry.approximate
            ? (labels.approximate || 'Approx. __DATE__').replace('__DATE__', date)
            : date;
        };

        const currentElement = this.querySelector('[data-price-history-current]');
        if (currentElement) currentElement.textContent = formatMoney(latest.price, latest.currency);

        const trendElement = this.querySelector('[data-price-history-trend]');
        let direction = 'same';
        let totalPercent = 0;
        let comparison = null;
        if (previous && previous.price !== latest.price) comparison = previous;
        if (!comparison && entries.length > 1 && first.price !== latest.price) comparison = first;
        if (comparison && comparison.price > 0) {
          totalPercent = ((latest.price - comparison.price) / comparison.price) * 100;
          if (totalPercent > 0.005) direction = 'up';
          if (totalPercent < -0.005) direction = 'down';
        }

        const percent = Math.abs(totalPercent).toLocaleString(locale, { maximumFractionDigits: 1 });

        if (trendElement) {
          trendElement.dataset.direction = direction;
          trendElement.textContent = direction === 'up'
            ? (labels.trendUp || 'Up __PERCENT__%').replace('__PERCENT__', percent)
            : direction === 'down'
              ? (labels.trendDown || 'Down __PERCENT__%').replace('__PERCENT__', percent)
              : labels.trendSame || 'No change';
        }

        const toggleMetaElement = this.querySelector('[data-price-history-toggle-meta]');
        if (toggleMetaElement) {
          toggleMetaElement.textContent = (labels.toggleCurrent || 'Current __PRICE__')
            .replace('__PRICE__', formatMoney(latest.price, latest.currency));
        }

        const signalElement = this.querySelector('[data-price-history-signal]');
        if (signalElement) {
          signalElement.dataset.direction = direction;
          signalElement.textContent = direction === 'down'
            ? labels.dealBadge || 'Great deal'
            : direction === 'up'
              ? labels.risingBadge || 'Price rising'
              : labels.steadyBadge || 'Price steady';
        }

        const narrativeElement = this.querySelector('[data-price-history-narrative]');
        if (narrativeElement) {
          let summary = entries.length < 2
            ? (labels.startSummary || 'Price tracking has started at __PRICE__. No earlier price changes are recorded yet.')
              .replace('__PRICE__', formatMoney(latest.price, latest.currency))
            : direction === 'down'
              ? (labels.dealSummary || 'Great deal — this price is __PERCENT__% below the last recorded price.')
                .replace('__PERCENT__', percent)
              : direction === 'up'
                ? (labels.risingSummary || 'Demand has moved this price __PERCENT__% higher since the last update. Grab it before the next price change.')
                  .replace('__PERCENT__', percent)
                : (labels.steadySummary || 'The price is holding steady at __PRICE__.')
                  .replace('__PRICE__', formatMoney(latest.price, latest.currency));
          if (latest.reason) {
            summary += ` ${(labels.latestContext || 'Latest update: __REASON__').replace('__REASON__', latest.reason)}`;
          }
          narrativeElement.dataset.direction = direction;
          narrativeElement.textContent = summary;
        }

        const metaElement = this.querySelector('[data-price-history-meta]');
        if (metaElement && hasRecordedHistory) {
          const tracking = (labels.trackingSince || 'Tracking since __DATE__').replace('__DATE__', formatDate(first));
          const range = (labels.range || '__LOW__ low · __HIGH__ high')
            .replace('__LOW__', formatMoney(low, latest.currency))
            .replace('__HIGH__', formatMoney(high, latest.currency));
          metaElement.textContent = `${tracking} · ${range}`;
        }

        const emptyElement = this.querySelector('[data-price-history-empty]');
        const chartElement = this.querySelector('[data-price-history-chart]');
        if (entries.length > 1) {
          if (emptyElement) emptyElement.hidden = true;
          if (chartElement) chartElement.hidden = false;
          this.renderChart(entries, formatMoney, formatDate, labels);
        } else {
          if (emptyElement) emptyElement.hidden = false;
          if (chartElement) chartElement.hidden = true;
        }

        this.renderEvents(entries, hasRecordedHistory, formatMoney, formatDate, labels);
      }

      renderChart(entries, formatMoney, formatDate, labels) {
        const svg = this.querySelector('[data-price-history-svg]');
        const line = this.querySelector('[data-price-history-line]');
        const area = this.querySelector('[data-price-history-area]');
        const pointsGroup = this.querySelector('[data-price-history-points]');
        if (!svg || !line || !area || !pointsGroup) return;

        const prices = entries.map((entry) => entry.price);
        const minimum = Math.min(...prices);
        const maximum = Math.max(...prices);
        const span = maximum - minimum || Math.max(maximum * 0.1, 1);
        const paddedMinimum = minimum - span * 0.12;
        const paddedMaximum = maximum + span * 0.12;
        const width = 592;
        const height = 132;
        const left = 24;
        const top = 24;
        const bottom = 156;

        const coordinates = entries.map((entry, index) => {
          const x = left + (index / (entries.length - 1)) * width;
          const y = top + ((paddedMaximum - entry.price) / (paddedMaximum - paddedMinimum)) * height;
          return { x, y, entry };
        });

        const points = coordinates.map((point) => `${point.x.toFixed(2)},${point.y.toFixed(2)}`).join(' ');
        const areaPoints = coordinates.map((point) => `${point.x.toFixed(2)} ${point.y.toFixed(2)}`).join(' L ');
        line.setAttribute('points', points);
        area.setAttribute('d', `M ${coordinates[0].x} ${bottom} L ${areaPoints} L ${coordinates[coordinates.length - 1].x} ${bottom} Z`);
        pointsGroup.replaceChildren();

        coordinates.forEach((point) => {
          const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
          const title = document.createElementNS('http://www.w3.org/2000/svg', 'title');
          circle.setAttribute('class', 'PriceHistory__Point');
          circle.setAttribute('cx', point.x);
          circle.setAttribute('cy', point.y);
          circle.setAttribute('r', '6');
          title.textContent = `${formatDate(point.entry)}: ${formatMoney(point.entry.price, point.entry.currency)}${point.entry.reason ? ` — ${point.entry.reason}` : ''}`;
          circle.append(title);
          pointsGroup.append(circle);
        });

        const startDate = formatDate(entries[0]);
        const endDate = formatDate(entries[entries.length - 1]);
        svg.setAttribute('aria-label', (labels.chart || 'Price history from __START__ to __END__')
          .replace('__START__', startDate)
          .replace('__END__', endDate));

        const startElement = this.querySelector('[data-price-history-start]');
        const endElement = this.querySelector('[data-price-history-end]');
        if (startElement) startElement.textContent = startDate;
        if (endElement) endElement.textContent = endDate;

        this.setupScrubber(svg, coordinates, formatMoney, formatDate);
      }

      setupScrubber(svg, coordinates, formatMoney, formatDate) {
        const target = this.querySelector('[data-price-history-scrub-target]');
        const scrubber = this.querySelector('[data-price-history-scrubber]');
        const scrubLine = scrubber ? scrubber.querySelector('.PriceHistory__ScrubLine') : null;
        const scrubPoint = scrubber ? scrubber.querySelector('.PriceHistory__ScrubPoint') : null;
        const tooltip = this.querySelector('[data-price-history-tooltip]');
        const tooltipDate = this.querySelector('[data-price-history-tooltip-date]');
        const tooltipPrice = this.querySelector('[data-price-history-tooltip-price]');
        const tooltipReason = this.querySelector('[data-price-history-tooltip-reason]');
        if (!target || !scrubber || !scrubLine || !scrubPoint || !tooltip) return;

        target.setAttribute('aria-valuemin', '1');
        target.setAttribute('aria-valuemax', String(coordinates.length));
        target.dataset.index = String(coordinates.length - 1);

        let pointerActive = false;
        let hideTimer;

        const hide = () => {
          window.clearTimeout(hideTimer);
          scrubber.hidden = true;
          tooltip.hidden = true;
        };

        const show = (index) => {
          const safeIndex = Math.max(0, Math.min(coordinates.length - 1, index));
          const point = coordinates[safeIndex];
          const date = formatDate(point.entry);
          const price = formatMoney(point.entry.price, point.entry.currency);
          target.dataset.index = String(safeIndex);
          target.setAttribute('aria-valuenow', String(safeIndex + 1));
          target.setAttribute('aria-valuetext', `${date}, ${price}${point.entry.reason ? `, ${point.entry.reason}` : ''}`);
          scrubLine.setAttribute('x1', point.x);
          scrubLine.setAttribute('x2', point.x);
          scrubPoint.setAttribute('cx', point.x);
          scrubPoint.setAttribute('cy', point.y);
          tooltip.style.left = `${(point.x / 640) * 100}%`;
          tooltip.dataset.edge = point.x < 145 ? 'left' : point.x > 495 ? 'right' : 'center';
          if (tooltipDate) tooltipDate.textContent = date;
          if (tooltipPrice) tooltipPrice.textContent = price;
          if (tooltipReason) tooltipReason.textContent = point.entry.reason;
          scrubber.hidden = false;
          tooltip.hidden = false;
        };

        const showNearest = (clientX) => {
          const bounds = svg.getBoundingClientRect();
          if (!bounds.width) return;
          const viewBoxX = ((clientX - bounds.left) / bounds.width) * 640;
          let nearestIndex = 0;
          let nearestDistance = Number.POSITIVE_INFINITY;
          coordinates.forEach((point, index) => {
            const distance = Math.abs(point.x - viewBoxX);
            if (distance < nearestDistance) {
              nearestIndex = index;
              nearestDistance = distance;
            }
          });
          show(nearestIndex);
        };

        target.addEventListener('pointerdown', (event) => {
          window.clearTimeout(hideTimer);
          pointerActive = true;
          if (target.setPointerCapture) target.setPointerCapture(event.pointerId);
          showNearest(event.clientX);
        });

        target.addEventListener('pointermove', (event) => {
          if (event.pointerType === 'mouse' || pointerActive) showNearest(event.clientX);
        });

        target.addEventListener('pointerup', (event) => {
          pointerActive = false;
          if (target.hasPointerCapture && target.hasPointerCapture(event.pointerId)) {
            target.releasePointerCapture(event.pointerId);
          }
          if (event.pointerType !== 'mouse') hideTimer = window.setTimeout(hide, 1200);
        });

        target.addEventListener('pointercancel', () => {
          pointerActive = false;
          hide();
        });

        target.addEventListener('pointerleave', (event) => {
          if (!pointerActive && event.pointerType === 'mouse') hide();
        });

        target.addEventListener('focus', () => show(Number.parseInt(target.dataset.index, 10)));
        target.addEventListener('blur', hide);
        target.addEventListener('keydown', (event) => {
          let index = Number.parseInt(target.dataset.index, 10);
          if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') index -= 1;
          else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') index += 1;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = coordinates.length - 1;
          else return;
          event.preventDefault();
          show(index);
        });
      }

      renderEvents(entries, hasRecordedHistory, formatMoney, formatDate, labels) {
        const eventsElement = this.querySelector('[data-price-history-events]');
        if (!eventsElement || !hasRecordedHistory) return;
        eventsElement.replaceChildren();

        entries.slice().reverse().slice(0, 5).forEach((entry) => {
          const originalIndex = entries.indexOf(entry);
          const previous = originalIndex > 0 ? entries[originalIndex - 1] : null;
          let direction = 'same';
          if (previous && entry.price > previous.price) direction = 'up';
          if (previous && entry.price < previous.price) direction = 'down';

          const item = document.createElement('li');
          item.className = 'PriceHistory__Event';
          const top = document.createElement('div');
          top.className = 'PriceHistory__EventTop';
          const date = document.createElement('time');
          date.className = 'PriceHistory__EventDate';
          date.dateTime = entry.date;
          date.textContent = formatDate(entry);
          const price = document.createElement('strong');
          price.className = 'PriceHistory__EventPrice';
          price.textContent = formatMoney(entry.price, entry.currency);
          const change = document.createElement('span');
          change.className = 'PriceHistory__EventChange';
          change.dataset.direction = direction;
          change.textContent = direction === 'up'
            ? labels.increased || 'Price increased'
            : direction === 'down'
              ? labels.decreased || 'Price decreased'
              : labels.unchanged || 'Price unchanged';
          top.append(date, price);
          item.append(top, change);

          if (entry.reason) {
            const reason = document.createElement('p');
            reason.className = 'PriceHistory__EventReason';
            reason.textContent = entry.reason;
            item.append(reason);
          }

          eventsElement.append(item);
        });
      }
    }

    customElements.define('price-history', PriceHistory);
  }
  } catch(e) { console.error(e); }
})();

})();
